import type { FieldType, Operator } from './types';

export const operatorLabels: Record<Operator, string> = {
  '=': 'is',
  '!=': 'is not',
  '<': 'is less than',
  '>': 'is greater than',
  '<=': 'is less than or equal to',
  '>=': 'is greater than or equal to',
  contains: 'contains',
  beginsWith: 'starts with',
  endsWith: 'ends with',
  doesNotContain: 'does not contain',
  doesNotBeginWith: 'does not start with',
  doesNotEndWith: 'does not end with',
  null: 'is empty',
  notNull: 'is not empty',
  in: 'is any of',
  notIn: 'is none of',
  between: 'is between',
  notBetween: 'is not between',
  inLast: 'is in the last',
};

export const getOperatorLabel = (operator: Operator, fieldType?: FieldType) => {
  if (fieldType === 'date' || fieldType === 'datetime') {
    if (operator === '>=') return 'is on or after';
    if (operator === '<=') return 'is on or before';
  }
  return operatorLabels[operator];
};

export const operatorsByType: Record<FieldType, Operator[]> = {
  text: [
    '=',
    '!=',
    'contains',
    'beginsWith',
    'endsWith',
    'doesNotContain',
    'doesNotBeginWith',
    'doesNotEndWith',
    'in',
    'notIn',
    'null',
    'notNull',
  ],
  textarea: ['=', '!=', 'contains', 'doesNotContain', 'null', 'notNull'],
  email: ['=', '!=', 'contains', 'beginsWith', 'endsWith', 'null', 'notNull'],
  url: ['=', '!=', 'contains', 'beginsWith', 'null', 'notNull'],
  number: [
    '=',
    '!=',
    '<',
    '>',
    '<=',
    '>=',
    'between',
    'notBetween',
    'in',
    'notIn',
    'null',
    'notNull',
  ],
  date: ['<=', '>=', 'between'],
  datetime: ['<=', '>=', 'between'],
  time: ['<=', '>=', 'between'],
  duration: ['<=', '>=', 'between'],
  select: ['=', '!=', 'in', 'notIn', 'null', 'notNull'],
  boolean: ['=', '!=', 'null', 'notNull'],
};

export const isUnaryOperator = (operator: Operator) =>
  operator === 'null' || operator === 'notNull';
export const isRangeOperator = (operator: Operator) =>
  operator === 'between' || operator === 'notBetween';
export const isListOperator = (operator: Operator) => operator === 'in' || operator === 'notIn';
